var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.953,
    height: 44.076,
    viewBox: "0 0 32.953 44.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15882",
    "data-name": "Group 15882",
    transform: "translate(-66.1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15881",
    "data-name": "Group 15881",
    transform: "translate(66.1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M99.045,12.334,88.72,2H67.766A1.666,1.666,0,0,0,66.1,3.666V33.227H99.045Z",
    transform: "translate(-66.1 -2)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M326.8,10.668a1.666,1.666,0,0,0,1.666,1.666h8.668L326.8,2Z",
    transform: "translate(-304.18 -2)",
    fill: "#dbdfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M66.2,361.8v11.193a1.666,1.666,0,0,0,1.666,1.666H97.479a1.666,1.666,0,0,0,1.666-1.666V361.8Z",
    transform: "translate(-66.191 -330.582)",
    fill: "#f1786b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15879",
    "data-name": "Group 15879",
    transform: "translate(5.718 4.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M134.314,73.975a2.339,2.339,0,0,1-1.51-.59,1.953,1.953,0,0,1-.772-1.883c.382-2.23,4.529-4.269,6.941-5.275a79.282,79.282,0,0,0,3.15-10.039c-1.406-3.011-1.9-5.136-1.466-6.342a1.7,1.7,0,0,1,1.284-1.128l.087-.017.087.009a1.874,1.874,0,0,1,1.189.781c.651.885.8,2.317.434,4.26-.1.555-.278,1.354-.5,2.308a54.933,54.933,0,0,0,4.564,7.67,14.334,14.334,0,0,1,3.393-.13c1.848.191,2.239,1,2.308,1.466a1.778,1.778,0,0,1-1.258,1.761c-1.189.5-3.132.373-4.711-1.675-.069-.087-.139-.182-.208-.278a37.665,37.665,0,0,0-6.785,1.874c-.252.1-.495.191-.737.286-1.622,3.974-3.21,6.256-4.729,6.8a2.075,2.075,0,0,1-.755.139Zm4.078-6.342c-3.445,1.553-5.154,3.089-5.31,4.052a.891.891,0,0,0,.408.894,1.174,1.174,0,0,0,1.232.269C135.928,72.413,137.212,70.33,138.392,67.632Zm10.151-2.924a2.879,2.879,0,0,0,3.288,1.145c.416-.174.651-.469.625-.633s-.416-.469-1.371-.564A12.77,12.77,0,0,0,148.543,64.708Zm-5.692-7.063c-.529,2.039-1.249,4.494-2.091,6.872-.147.408-.286.8-.434,1.18a40.956,40.956,0,0,1,6.316-1.779A57.366,57.366,0,0,1,142.851,57.645Zm-.781-7.852a.627.627,0,0,0-.408.425c-.3.833.1,2.4.868,4.26q.1-.495.182-.911c.4-2.16.017-3.089-.252-3.445A.971.971,0,0,0,142.071,49.793Z",
    transform: "translate(-132.006 -48.7)",
    fill: "#f1786b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15880",
    "data-name": "Group 15880",
    transform: "translate(7.956 33.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M311.332,392.675h-1.987v-2.022h1.987a.677.677,0,0,0,0-1.354h-2.655a.678.678,0,0,0-.677.677v6.733a.677.677,0,0,0,1.354,0v-2.69h1.987a.672.672,0,1,0-.009-1.345Z",
    transform: "translate(-294.968 -389.3)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M159.848,389.4h-1.371a.678.678,0,0,0-.677.677v6.733a.677.677,0,0,0,1.354,0v-2.69h.694a2.36,2.36,0,1,0,0-4.72Zm0,3.366h-.694v-2.022h.694a1.011,1.011,0,0,1,0,2.022Z",
    transform: "translate(-157.8 -389.391)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M222.647,389.4h-1.77a.678.678,0,0,0-.677.677v6.733a.678.678,0,0,0,.677.677h1.77a4.043,4.043,0,1,0,0-8.086Zm0,6.724h-1.093v-5.388h1.093a2.694,2.694,0,0,1,0,5.388Z",
    transform: "translate(-214.786 -389.391)",
    fill: "#eff3f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.091063fac2c9044fc08c8db1538db2d1.svg";
export { ForwardRef as ReactComponent };